import { type PayFileLog, PayFileLogEvent, type PayFileStatus } from "@/graphql/codegen/graphql"

const SCHEDULED_PAY_DATE_CHIP_PREFIX = "Scheduled Pay Date: "

export const formatPayFileDateRangeChipLabel = (from: string | undefined, to: string | undefined): string => {
  if (from && to) return `${SCHEDULED_PAY_DATE_CHIP_PREFIX}${from} to ${to}`
  if (from) return `${SCHEDULED_PAY_DATE_CHIP_PREFIX}from ${from}`
  if (to) return `${SCHEDULED_PAY_DATE_CHIP_PREFIX}until ${to}`
  return ""
}

// AK-5104 AC6/AC7: the titles for the two ways an approved pay file can fail to be sent.
const PAY_FILE_FAILURE_EVENT_TO_TITLE: Partial<Record<PayFileLogEvent, string>> = {
  [PayFileLogEvent.GenerationFailed]: "Pay File Generation Failed.",
  [PayFileLogEvent.SftpDeliveryFailed]: "SFTP Delivery Failed.",
}

// The list fragment's selection of the GraphQL PayFileLog type.
export type PayFileLatestLog =
  | (Pick<PayFileLog, "payFileLogId" | "event" | "description"> & { __typename: "PayFileLog" })
  | null
  | undefined

export interface PayFileFailure {
  title: string
  description: string | null
}

// Only the generation and SFTP delivery failures have a message of their own; any other latest log
// entry means the pay file has no failure to explain.
export const getPayFileFailure = (latestLog: PayFileLatestLog): PayFileFailure | undefined => {
  const title = latestLog ? PAY_FILE_FAILURE_EVENT_TO_TITLE[latestLog.event] : undefined
  if (!latestLog || !title) return undefined

  return { title, description: latestLog.description ?? null }
}

export interface PayFileProcessingOutcome {
  status: PayFileStatus
  latestLog: PayFileLatestLog
}
